import { usePortalStore } from "../store";

export default defineNuxtPlugin({
	name: "pinia",
	order: 1040,
	setup: ({ $pinia }) => {
		return {
			provide: {
				store: usePortalStore($pinia),
			},
		};
	},
});
